import {React,useState,useEffect} from 'react'
import logo from "../assets/vlogo.png"
import Fade from 'react-reveal/Fade';
import Flash from 'react-reveal/Flash';
import Img from '../Components/Img';
import { Container,Navbar, NavbarBrand} from 'reactstrap';
import { UncontrolledCarousel } from 'reactstrap';
import {compering, content, design, dev, documentation, event, organizers, president, promotions, treasurers, wmentors, workshop} from "../Components/Info"

const Thanks = ()=> {
    const [intro, setIntro] = useState(true)
    const [intro1, setIntro1] = useState(false)
    const [start, setStart] = useState(false)

    useEffect(() => {
        organizers.forEach((picture) => {
            const img = new Image();
            img.src = picture.img;
        });
        president.forEach((picture) => {
            const img = new Image();
            img.src = picture.img;
        });
        wmentors.forEach((picture) => {
            const img = new Image();
            img.src = picture.img;
        });
        setTimeout(() => {
            setIntro(false)
            setIntro1(true)
            content.forEach((picture) => {
                const img = new Image();
                img.src = picture.img;
            });
            treasurers.forEach((picture) => {
                const img = new Image();
                img.src = picture.img;
            });
            setTimeout(()=>{setIntro1(false)},2000)
            setTimeout(()=>{setStart(true)},3000)
        }, 2500);
        
    }, [])

    return (
        <div className="page">
     
           
           {(!start)?(<div>
            <div className="intro" style={{opacity:(intro)?(1):(0)}}>
                <Fade>
                    <h1 className="text-white text-center" >Thank you for making this event happen✨</h1>             
                </Fade>
            </div>
            <div className="intro1" style={{opacity:(intro1)?(1):(0)}}>
                <img alt="logo" src={logo}></img>
            </div>
            </div>):(null)}

            {(start)?(
                <div className="pagehome" onContextMenu={(e)=>e.preventDefault()}>
                    <Fade><Navbar dark>
                        <NavbarBrand href="/thanks" className="mx-auto nv"><img src={logo} alt="logo" height="55rem"></img>Special mention</NavbarBrand>
                    </Navbar></Fade>
                    <Container>

                    <div className="note my-4">
                            <Fade>
                                <p className="notes"><b>Dear staffs, seniors, juniors and our fellow batch mates,</b><br></br>
                                The prep for vidyutrenz began just 18 days prior to the event. But the support, dedication, hard-work you all put into this event made us reach whopping 1000+ registrations. Thanking for it alone, isn't sufficient.<br></br>
                                <br></br><b>To the juniors and our batchmates,</b><br></br>
                                You people accepted this to be your own event, and the immediate dedication and hard-work you people put into the ground work made us reach thousands of screens. The level of attention you gave the event is humongous and worth noting. The appreciations you sent us, the opinions you had about the event during its making, made us sculpt it even better. You people deserve the major share of this success.<br></br>
                                <br></br><b>And finally to the seniors,</b><br></br>
                                You were by our side since the freshman year and the bond we developed is a token worth cherishing. You have taught us dedication, teamwork, patience and persistence. We learnt every aspect beyond just books through experiences and we never knew how important they were.You are the best of whom we have known.
                                We dedicate the success of Vidyutrenz '21, to each and every one of our seniors.<br></br>
                                <br></br>To make every struggle count and recognize the talents which you might haven't known,we introduce you the<b> people behind Vidyutrenz '21.</b>
                                </p>
                                </Fade>
                                <Fade>
                                    <div>
                                <h3 className="text-white mt-4 py-3 mx-auto batchhead text-center">2017-2021 batch</h3> 
                                <UncontrolledCarousel items={[
                                    {
                                    src: 'https://firebasestorage.googleapis.com/v0/b/vidyutrenz3.appspot.com/o/grp%2Fgrp1.jpeg?alt=media&token=6dbeece6-8806-408a-b7e2-b928ae7e6603',
                                    altText: 'Slide 1',
                                    key: '1'
                                    },
                                    {
                                    src: 'https://firebasestorage.googleapis.com/v0/b/vidyutrenz3.appspot.com/o/grp%2Fgrp2.jpeg?alt=media&token=b500e47c-3c1f-4ca5-a3dd-cc9f865bf5ab',
                                    altText: 'Slide 2',
                                    key: '2'
                                    },
                                ]} />
                                </div>
                                </Fade>
                        </div>

                        <div className="president my-5">
                        <Fade><h1 className="text-white text-center mb-4 heading">President</h1></Fade>
                            <div className="box">
                                {president.map(person=>(<div className="cr"><p className="crown">👑</p><Img name={person.name} img={person.img}></Img></div>))}                    
                            </div>
                        </div>

                        <div className="org my-5">
                        <Fade><h1 className="text-white text-center mb-4 heading">Organizers</h1></Fade>
                            <div className="box">
                            {organizers.map(person=>(<Img name={person.name} img={person.img}></Img>))}                  
                            </div>
                        </div>

                        <div className="wmentors my-5">
                        <Fade><h1 className="text-white text-center mb-4 heading">Workshop mentors</h1></Fade>
                            <div className="box">
                                {wmentors.map(person=>(<div className="cr"><p className="crown">👑</p><Img name={person.name} img={person.img}></Img></div>))}      
                                <Img name="Partha sarathy" img="https://firebasestorage.googleapis.com/v0/b/vidyutrenz4.appspot.com/o/wmentors%2Fparthasarathy.jpeg?alt=media&token=13c17135-51e5-40a1-8035-816ecd1a32ec"></Img>              
                            </div>
                        </div>

                        <div className="content my-5">
                        <Fade><h1 className="text-white text-center mb-4 heading">Content team</h1></Fade>
                            <div className="box">
                            <div className="cr"><p className="crown">👑</p><Img name={"Raveena"} img={"https://firebasestorage.googleapis.com/v0/b/vidyutrenz3.appspot.com/o/raveena%2Fraveena.jpeg?alt=media&token=7799ba74-d963-42d8-a4ea-83fadf94b0aa"}></Img></div>
                                {content.map(person=>(<Img name={person.name} img={person.img}></Img>))}                    
                            </div>
                        </div>

                        <div className="design my-5">
                        <Fade><h1 className="text-white text-center mb-4 heading">Design team</h1></Fade>
                            <div className="box">
                            <div className="cr"><p className="crown">👑</p><Img name={"Mukilan"} img={"https://firebasestorage.googleapis.com/v0/b/vidyutrenz3.appspot.com/o/design%2Fmukilan.jpeg?alt=media&token=11cf2480-39df-4890-b19d-043cfdd56a44"}></Img></div>
                                {design.map(person=>(<Img name={person.name} img={person.img}></Img>))}                    
                            </div>
                        </div>

                        <div className="dev my-5">
                        <Fade><h1 className="text-white text-center mb-4 heading">Web Development team</h1></Fade>
                            <div className="box">
                                {dev.map(person=>(<Img name={person.name} img={person.img}></Img>))}
                            </div>
                        </div>

                        <div className="promotions my-5">
                        <Fade><h1 className="text-white text-center mb-4 heading">Promotions and media team</h1></Fade>
                            <div className="box">
                                {promotions.map(person=>(<Img name={person.name} img={person.img}></Img>))}
                            </div>
                        </div>

                        <div className="treasurers my-5">
                        <Fade><h1 className="text-white text-center mb-4 heading">Treasurers</h1></Fade>
                            <div className="box">
                                {treasurers.map(person=>(<Img name={person.name} img={person.img}></Img>))}                    
                            </div>
                        </div>

                        <div className="compering my-5">
                        <Fade><h1 className="text-white text-center mb-4 heading">Compering team</h1></Fade>
                            <div className="box">
                                {compering.map(person=>(<Img name={person.name} img={person.img}></Img>))}                    
                            </div>
                        </div>

                        <div className="documentation my-5">
                        <Fade><h1 className="text-white text-center mb-4 heading">Documentation team</h1></Fade>
                            <div className="box">
                                {documentation.map(person=>(<Img name={person.name} img={person.img}></Img>))}                    
                            </div>
                        </div>

                        <div className="workshop my-5">
                        <Fade><h1 className="text-white text-center mb-4 heading">Workshop Organizers</h1></Fade>
                            <div className="box">
                                {workshop.map(person=>(<Img name={person.name} img={person.img}></Img>))}
                            </div>
                        </div>

                        <div className="event my-5">
                        <Fade><h1 className="text-white text-center mb-4 heading">Event Organizers</h1></Fade>
                            <div className="box">
                                {event.map(person=>(<Img name={person.name} img={person.img}></Img>))}
                            </div>
                        </div>
                        
                    </Container> 
                    <div className="end">
                        <Container>
                            <Flash>
                                <div>
                                    <h3 className="text-center mb-0">Meet you in </h3>
                                    <h2 className="text-center mb-0">V i d y u t r e n z  '22</h2>
                                </div>
                            </Flash>
                        </Container>
                    </div>
                </div>
            ):(null)}
       
        </div>
    )
}

export default Thanks;